import request from '../api/request'
import md5 from '../utils/md5'

// 科室分类列表
export default {
  getFKEY() {
    return md5.hexMD5('USERNAME' + this.date2str() + ',fh,')
  },
  date2str() {
    var d = new Date()
    var curr_date = d.getDate()
    var curr_month = d.getMonth() + 1
    var curr_year = d.getFullYear()
    String(curr_month).length < 2 ? (curr_month = '0' + curr_month) : curr_month
    String(curr_date).length < 2 ? (curr_date = '0' + curr_date) : curr_date
    var yyyyMMdd = curr_year + '' + curr_month + '' + curr_date
    return yyyyMMdd
  },

  // 获取科室
  departcategorylist(parm) {
    return request({
      url: '/appwebsit/departcategorylist',
      method: 'post',
      params: parm,
    })
  },
  // 科室详情
  departdetail(parm) {
    return request({
      url: '/appwebsit/departdetail',
      method: 'post',
      params: parm,
    })
  },
  //院内公告
  noticelist(parm) {
    return request({
      url: '/appwebsit/noticelist',
      method: 'post',
      params: parm,
    })
  },
  //本院专家
  doctorlist(parm) {
    return request({
      url: '/appwebsit/doctorlist',
      method: 'post',
      params: parm,
    })
  },
  //本院专家详情
  doctordetail(parm) {
    return request({
      url: '/appwebsit/doctordetail',
      method: 'post',
      params: parm,
    })
  },
  //天使列表
  nurselist(parm) {
    return request({
      url: '/appwebsit/nurselist',
      method: 'post',
      params: parm,
    })
  },
  //天使详情
  nursedetail(parm) {
    return request({
      url: '/appwebsit/nursedetail',
      method: 'post',
      params: parm,
    })
  },
  //医院新闻列表
  newslist(parm) {
    return request({
      url: '/appwebsit/newslist',
      method: 'post',
      params: parm,
    })
  },
  //医院文化列表
  culturelist(parm) {
    return request({
      url: '/appwebsit/culturelist',
      method: 'post',
      params: parm,
    })
  },
  //患者心声列表
  aspirationlist(parm) {
    return request({
      url: '/appwebsit/aspirationlist',
      method: 'post',
      params: parm,
    })
  },
  //招聘信息列表
  recruitlist(parm) {
    return request({
      url: '/appwebsit/recruitlist',
      method: 'post',
      params: parm,
    })
  },
  //医疗设备列表
  devicelist(parm) {
    return request({
      url: '/appwebsit/devicelist',
      method: 'post',
      params: parm,
    })
  },
  //荣誉资质列表
  honorlist(parm) {
    return request({
      url: '/appwebsit/honorlist',
      method: 'post',
      params: parm,
    })
  },
  //领导团队列表
  leaderlist(parm) {
    return request({
      url: '/appwebsit/leaderlist',
      method: 'post',
      params: parm,
    })
  },
  //医院简介
  hospitaldetail(parm) {
    return request({
      url: '/appwebsit/hospitaldetail',
      method: 'post',
      params: parm,
    })
  },
  //领导团队
  leaderlist(parm) {
    return request({
      url: '/appwebsit/leaderlist',
      method: 'post',
      params: parm,
    })
  },
  //招聘详情
  recruitdetail(parm) {
    return request({
      url: '/appwebsit/recruitdetail',
      method: 'post',
      params: parm,
    })
  },
  //联系我们
  contactdetail(parm) {
    return request({
      url: '/appwebsit/contactdetail',
      method: 'post',
      params: parm,
    })
  },
  //新闻详情
  newsdetail(parm) {
    return request({
      url: '/appwebsit/newsdetail',
      method: 'post',
      params: parm,
    })
  },
  //医院文化详情
  culturedetail(parm) {
    return request({
      url: '/appwebsit/culturedetail',
      method: 'post',
      params: parm,
    })
  },
  //患者心声详情
  aspirationdetail(parm) {
    return request({
      url: '/appwebsit/aspirationdetail',
      method: 'post',
      params: parm,
    })
  },
  //banner列表
  bannerlist(parm) {
    return request({
      url: '/appwebsit/bannerlist',
      method: 'post',
      params: parm,
    })
  },
  //banner列表
  comforlist(parm) {
    return request({
      url: '/appwebsit/comforlist',
      method: 'post',
      params: parm,
    })
  },
  //banner列表
  homepagevideo(parm) {
    return request({
      url: '/appwebsit/homepagevideo',
      method: 'post',
      params: parm,
    })
  },
}
